module.exports = __webpack_public_path__ + "static/media/1.590cfa5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/healthcare-update-for-pharmacists/1.jpg
// module id = 663
// module chunks = 0